/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Meta_DescriptionInputs */

const id_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari penawaran dari Epic Games Store.`)
};

const ms_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari tawaran dari Epic Games Store.`)
};

const da_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter tilbud fra Epic Games Store.`)
};

const de_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche nach Angeboten im Epic Games Store.`)
};

const en_us2_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for offers from the Epic Games Store.`)
};

const es_es2_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar juegos y contenido de la Epic Games Store.`)
};

const es_mx2_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar ofertas de la Epic Games Store.`)
};

const fil_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga offer mula sa Epic Games Store.`)
};

const fr_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des offres sur l'Epic Games Store.`)
};

const it_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca offerte dall'Epic Games Store.`)
};

const hu_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok keresése az Epic Games Store-ból.`)
};

const nl_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek naar aanbiedingen van de Epic Games Store.`)
};

const no_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter tilbud fra Epic Games Store.`)
};

const pl_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj ofert z Epic Games Store.`)
};

const pt_br2_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busque jogos e conteúdos da Epic Games Store.`)
};

const pt_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquise ofertas da Epic Games Store.`)
};

const ro_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută oferte din Epic Games Store.`)
};

const fi_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etsi tarjouksia Epic Games Storesta.`)
};

const sv_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök efter erbjudanden från Epic Games Store.`)
};

const vi_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm ưu đãi từ Epic Games Store.`)
};

const tr_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki tekliflerde arama yapın.`)
};

const cs_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledejte nabídky z Epic Games Store.`)
};

const bg_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на оферти от Epic Games Store.`)
};

const ru_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск предложений в Epic Games Store.`)
};

const uk_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук пропозицій з Epic Games Store.`)
};

const ar_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث عن العروض من Epic Games Store.`)
};

const hi_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store से ऑफ़र खोजें।`)
};

const th_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาข้อเสนอจาก Epic Games Store`)
};

const ja_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store のオファーを検索。`)
};

const zh_cn2_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索Epic游戏商城的目录项。`)
};

const zh_hant1_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋Epic遊戲商城的目錄項目。`)
};

const ko_search_meta_description = /** @type {(inputs: Search_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 오퍼를 검색합니다.`)
};

/**
* | output |
* | --- |
* | "Search for offers from the Epic Games Store." |
*
* @param {Search_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_meta_description = /** @type {((inputs?: Search_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_meta_description(inputs)
	if (locale === "ms") return ms_search_meta_description(inputs)
	if (locale === "da") return da_search_meta_description(inputs)
	if (locale === "de") return de_search_meta_description(inputs)
	if (locale === "en-US") return en_us2_search_meta_description(inputs)
	if (locale === "es-ES") return es_es2_search_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_search_meta_description(inputs)
	if (locale === "fil") return fil_search_meta_description(inputs)
	if (locale === "fr") return fr_search_meta_description(inputs)
	if (locale === "it") return it_search_meta_description(inputs)
	if (locale === "hu") return hu_search_meta_description(inputs)
	if (locale === "nl") return nl_search_meta_description(inputs)
	if (locale === "no") return no_search_meta_description(inputs)
	if (locale === "pl") return pl_search_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_search_meta_description(inputs)
	if (locale === "pt") return pt_search_meta_description(inputs)
	if (locale === "ro") return ro_search_meta_description(inputs)
	if (locale === "fi") return fi_search_meta_description(inputs)
	if (locale === "sv") return sv_search_meta_description(inputs)
	if (locale === "vi") return vi_search_meta_description(inputs)
	if (locale === "tr") return tr_search_meta_description(inputs)
	if (locale === "cs") return cs_search_meta_description(inputs)
	if (locale === "bg") return bg_search_meta_description(inputs)
	if (locale === "ru") return ru_search_meta_description(inputs)
	if (locale === "uk") return uk_search_meta_description(inputs)
	if (locale === "ar") return ar_search_meta_description(inputs)
	if (locale === "hi") return hi_search_meta_description(inputs)
	if (locale === "th") return th_search_meta_description(inputs)
	if (locale === "ja") return ja_search_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_search_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_meta_description(inputs)
	return ko_search_meta_description(inputs)
});
export { search_meta_description as "search.meta.description" }